import { unauthenticatedApi } from "@/lib/api/client";

export interface CheckEmailResponse {
  emailVerified?: boolean;
  exists: boolean;
  isUser?: boolean;
  projectId?: number;
  userId?: number;
}

export interface VerifyEmailRequest {
  code: string;
  userId: number;
}

export interface VerifyEmailResponse {
  alreadyVerified?: boolean;
  email: string;
  message: string;
  success: boolean;
  userId: number;
  verified?: boolean;
}

export interface ResendCodeRequest {
  email: string;
}

export interface ResendCodeResponse {
  message: string;
  success: boolean;
}

/**
 * API for direct purchase flow (users created by PHP after Stripe payment)
 * Uses /auth endpoints that work with the users table directly
 */
export const directPurchaseApi = {
  checkEmail: (email: string): Promise<CheckEmailResponse> =>
    unauthenticatedApi
      .url(`/auth/check-email/${encodeURIComponent(email)}`)
      .get()
      .json<CheckEmailResponse>(),

  resendCode: (data: ResendCodeRequest): Promise<ResendCodeResponse> =>
    unauthenticatedApi
      .url("/auth/resend-code")
      .post(data)
      .json<ResendCodeResponse>(),

  verifyEmail: (data: VerifyEmailRequest): Promise<VerifyEmailResponse> =>
    unauthenticatedApi
      .url("/auth/verify-email")
      .post(data)
      .json<VerifyEmailResponse>(),
};
